import styled from 'styled-components'

export const Card = styled.div<{ selected: boolean }>`
  display: flex;
  width: 100%;
  height: 45px;

  align-items: center;
  padding: 0 0.3rem;
  justify-content: space-between;

  transition: ${({ selected }) => (selected ? '0.5 1s' : '0 1s')};
  background: #f0f2f5;

  border-radius: 10px;
  @media (max-width: 768px) {
    display: none;
    margin: 0rem 1rem 1rem 0rem;
  }
`

export const Slider = styled.div<{ x: number; offset: number }>`
  box-shadow: 0px 4px 19px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  width: 110px;
  height: 36px;
  border-radius: 7px;
  opacity: 0.5;
  pointer-events: none;

  position: absolute;

  will-change: transform;
  transition: all 250ms cubic-bezier(0.2, 0.5, 0.5, 1.3);
  transform: translateX(
    ${({ x, offset }) => `${x - offset}px`}
      // tp === 0 ? '0' : tp === 1 ? '100%' : tp === 2 ? '200%' : tp === 3 ? '300%' : '400%'}
  );
  &:before {
    background-color: red;
  }
  @media (max-width: 768px) {
    display: none;
  }
`
export const DropdownBox = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: unset;
    position: relative;
    display: inline-block;
  }
`
export const Dropdown = styled.div`
  position: absolute; 
  top:100%;
  right:50%;
  /* left: 0;  */
  /* width: 300px; */
  /* top: 5rem; */
  /* position:static; */
  width:100vw;
  z-index: 90;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14);
  }
    @media (max-width: 480px) {
    left:-100%;
  }

`
export const IconStyled = styled.button`
  padding: 0 5px;
  border: 0;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  outline: 0;
  font-size: 40px;
`
